import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/core/toast.service';
import { Component,  Inject,  OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CancelOrderItemService } from '../../services/cancel-order-item.service';
@Component({
  selector: 'app-cancel-order-item',
  templateUrl: './cancel-order-item.component.html',
  styleUrls: ['./cancel-order-item.component.scss']
})
export class CancelOrderItemComponent implements OnInit {
  /* --------------------------- change status form --------------------------- */
  changeStatusForm = this.fb.group({
    item_id : [null, [Validators.required]],
    supplies_order_id : [null, [Validators.required]]
  });
  /* ------------------------------- Constructor ------------------------------ */
  constructor(
    private fb: FormBuilder,
    private _dialogRef: MatDialogRef<CancelOrderItemComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private toast: ToastService,
    private spinner: NgxSpinnerService,
    private cancelOrderItemService: CancelOrderItemService
  ) { }
/* ---------------------------- Life cycle hooks ---------------------------- */
  ngOnInit(): void {
    this.changeStatusForm.patchValue(this.data)
  }

  /* ---------------------------- Custom Functions ---------------------------- */
  dialogClose(status: string) {
    // this._dialogRef.close(status);

    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp");
    setTimeout(() => { this._dialogRef.close(status); }, 1000);
  }

  /* --------------------------------- Getters -------------------------------- */
  get status(){
    return this.changeStatusForm.get('status');
  }
  async updateStatus(){
    if(this.changeStatusForm.invalid){
      this.toast.openSnackBar('Please enter valid details');
      return;
    }
    this.spinner.show();
    try {
      await this.cancelOrderItemService.cancelOrderItem(this.changeStatusForm.value);
        this.spinner.hide();
        this.toast.openSnackBar('Order item cancelled successfully');
        this.dialogClose('yes');
    } catch(error) {
      this.spinner.hide();
       this.toast.openSnackBar('Unable to cancel order item');
    }
  }
}


